/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from './ui/RefreshButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Switch } from './ui/switch';
import {
  Coins, Package, Gift, Clock, Zap, Users, TrendingUp, TrendingDown,
  Plus, Edit, Trash2, Eye, Search, Filter, Download, RefreshCw,
  UserPlus, Cake, Award, ShoppingCart, FileText, Key, AlertTriangle,
  CheckCircle, XCircle, Calendar, Timer, Percent, Hash, ArrowUpRight,
  ArrowDownRight, BarChart3, PieChart, Activity, Settings, Star, CreditCard,
  HelpCircle, BookOpen
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import StripeCheckoutButton from './StripeCheckoutButton';
import Sparkline from './credits/Sparkline';
import CreditUsagePlansTab from './CreditUsagePlansTab';
import CreditStatsAdvancedTab from './CreditStatsAdvancedTab';
import CreditAlertsAdminTab from './CreditAlertsAdminTab';


export const GCDuplicateModal = ({ ctx }) => {
  const {
    actions, activeTab, attributeForm, attributeSearch, bonusForm, bonusRules,
    bulkAttributeForm, creditTypes, duplicateRaison, duplicateSource, duplicateTargetSearch,
    duplicateTargetUserId, editForm, editTarget, editingBonus, editingPack, loading,
    packForm, packs, searchTerm, selectedUserIds, showAttributeModal, showBonusModal,
    showBulkAttributeModal, showDuplicateModal, showEditModal, showPackModal, sparkSeries, stats,
    transactions, userBalances,
    setActions, setActiveTab, setAttributeForm, setAttributeSearch, setBonusForm, setBonusRules,
    setBulkAttributeForm, setCreditTypes, setDuplicateRaison, setDuplicateSource, setDuplicateTargetSearch,
    setDuplicateTargetUserId, setEditForm, setEditTarget, setEditingBonus, setEditingPack,
    setLoading, setPackForm, setPacks, setSearchTerm, setSelectedUserIds, setShowAttributeModal,
    setShowBonusModal, setShowBulkAttributeModal, setShowDuplicateModal, setShowEditModal, setShowPackModal,
    setSparkSeries, setStats, setTransactions, setUserBalances,
    exportUsersCsv, filteredUsers, handleAttributeCredits, handleBulkAttribute, handleBulkDelete,
    handleConfirmDuplicate, handleDeletePack, handleDeleteUserCredits, handleExportFiltered,
    handleExportSelection, handleSaveBonus, handleSaveEdit, handleSavePack, loadData, openDuplicateModal,
    openEditModal, renderIcon, resetPackForm, toggleSelectAllFiltered, toggleUserSelection,
    getAuthHeader, CountdownWidget, StatsCard, COLORS, AVAILABLE_ICONS,
  } = ctx;
  return (
      <Dialog open={showDuplicateModal} onOpenChange={setShowDuplicateModal}>
        <DialogContent className="max-w-lg" data-testid="credits-duplicate-modal">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <RefreshCw className="w-5 h-5 text-emerald-600" />
              Dupliquer les crédits
            </DialogTitle>
            {duplicateSource && (
              <DialogDescription>
                Source : {duplicateSource.user_info?.prenom} {duplicateSource.user_info?.nom} ({duplicateSource.total_disponible || 0} crédits)
              </DialogDescription>
            )}
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div>
              <Label>Rechercher l'utilisateur cible</Label>
              <Input
                placeholder="Nom, prénom ou email…"
                value={duplicateTargetSearch}
                onChange={(e) => {
                  setDuplicateTargetSearch(e.target.value);
                  setDuplicateTargetUserId('');
                }}
                data-testid="credits-duplicate-search"
              />
              {duplicateTargetSearch && (
                <div className="mt-2 max-h-48 overflow-y-auto border rounded-lg divide-y">
                  {userBalances
                    .filter((u) => {
                      if (u.user_id === duplicateSource?.user_id) return false;
                      const s = duplicateTargetSearch.toLowerCase();
                      const i = u.user_info || {};
                      return (
                        (i.nom || '').toLowerCase().includes(s) ||
                        (i.prenom || '').toLowerCase().includes(s) ||
                        (i.email || '').toLowerCase().includes(s)
                      );
                    })
                    .slice(0, 10)
                    .map((u) => (
                      <button
                        key={u.user_id}
                        type="button"
                        onClick={() => {
                          setDuplicateTargetUserId(u.user_id);
                          setDuplicateTargetSearch(`${u.user_info?.prenom || ''} ${u.user_info?.nom || ''} (${u.user_info?.email || ''})`);
                        }}
                        className={`w-full text-left px-3 py-2 text-sm hover:bg-emerald-50 ${duplicateTargetUserId === u.user_id ? 'bg-emerald-100' : ''}`}
                        data-testid={`credits-duplicate-target-${u.user_id}`}
                      >
                        <div className="font-medium">{u.user_info?.prenom} {u.user_info?.nom}</div>
                        <div className="text-xs text-gray-500">{u.user_info?.email}</div>
                      </button>
                    ))}
                </div>
              )}
            </div>
            <div>
              <Label>Raison *</Label>
              <Textarea
                value={duplicateRaison}
                onChange={(e) => setDuplicateRaison(e.target.value)}
                data-testid="credits-duplicate-raison"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDuplicateModal(false)}>Annuler</Button>
            <Button
              onClick={handleConfirmDuplicate}
              className="bg-emerald-600 hover:bg-emerald-700"
              disabled={!duplicateTargetUserId}
              data-testid="credits-duplicate-confirm"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Dupliquer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default GCDuplicateModal;
